window.recentlyViewed = window.recentlyViewed || {};

recentlyViewed.RecentlyViewedProducts = (function() {
  function RecentlyViewedProducts(element) {
  	this.container = document.querySelector('[data-section-type="' + element + '"]');
    
    if(!this.container) {
      return;
    }
    try {
      this.options = JSON.parse(this.container.getAttribute('data-section-settings'));
    } catch (error) {
      console.log('Invalid section settings:', error);
      this.options = {};
    }

    if (this.options['productId']) {
      this.saveCurrentProduct();
    }
    
    this.fetchProducts();
  }
    
  RecentlyViewedProducts.prototype.fetchProducts = function() {
  	var _this = this;   
    var queryString = this.getSearchQueryString();

    if (queryString === '') {
      return;
    }
    
    fetch(("/search?view=recently-viewed-products&type=product&q=").concat(queryString), {
      credentials: 'same-origin',
      method: 'GET'
    })
    .then(function (response) {
      response.text().then(function (content) {
      	var blankDivElement = document.createElement('div');
        blankDivElement.innerHTML = content;

        var container = _this.container.querySelector('.recentlyviewed__container');
        var newContent = blankDivElement.querySelector('[data-section-type="recently-viewed-products"] .recentlyviewed__container');
        if (!newContent) return;

        container.innerHTML = newContent.innerHTML;

        var productCards = container.querySelectorAll('.slider__item');
        var totalProducts = productCards.length;

        if (totalProducts >= 3) {
          _this.container.parentNode.style.display = 'block';
        } else {
          _this.container.parentNode.style.display = 'none';
        }

        if (totalProducts <= 3) {
          _this.container.querySelector('.recently-viewed-product').classList.add('centered');
        }
        else {
          _this.container.querySelector('.recently-viewed-product').classList.remove('centered');
        }
      })
    })
  }
  
  RecentlyViewedProducts.prototype.saveCurrentProduct = function() {
    /*
     * - Check if the current product already exists, and if it does not, add it at the start
     * - Then, we save the current product into the local storage, by keeping only the 8 most recent
    */    
    var items = JSON.parse(localStorage.getItem('mmRecentlyViewedProducts') || '[]'),
        productId = this.options['productId']; 

    if (!items.includes(productId)) {
      items.unshift(productId);
    }
    else {
      let index = items.indexOf(productId);
      if (index !== -1) {
        items.splice(index, 1); 
        items.unshift(productId);
      }
    }
    
    try {
      localStorage.setItem('mmRecentlyViewedProducts', JSON.stringify(items.slice(0, 8)));
    } 
    catch (error) {
      console.log('Failed to save to recently viewed product:', error);
    }
  }
  
  RecentlyViewedProducts.prototype.getSearchQueryString = function() {
    var items = [];
    try {
      items = JSON.parse(localStorage.getItem('mmRecentlyViewedProducts') || '[]');
    } catch (error) {
      console.log('Failed to parse recently viewed products:', error);
    }
    if (items.includes(this.options['productId'])) {
      items.splice(items.indexOf(this.options['productId']), 1);
    }

    return items.map(function (item) {
      return 'id:' + item;
    }).join(' OR ');
  }
    
  return RecentlyViewedProducts;
})();

new recentlyViewed.RecentlyViewedProducts('recently-viewed-products');